<template>
  <div class="burger">
    <div class="burger-block" :class="{ 'is-active': isBurgerBlockActive, 'is-created': isBurgerBlockCreated }">

      <!-- Burger list -->
      <div class="burger-block-list" v-if="isCategoriesLoaded">
        <category-burger-link v-for="item in categories" v-if="item.product_count > 0" :item="item" :key="item.id" />
      </div>
      <div v-else>
        <bounce-loader />
      </div>
      <!---->

    </div>
    <burger-block v-if="burgerData.current_list && isBurgerActive"
                  :current-list="burgerData.current_list"
                  :list-naming="burgerData.list_naming"
                  :current-category="burgerData.current_category"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CategoryBurgerLink from 'theme/components/core/blocks/Shop/Navigation/CategoryBurgerLink'
import BurgerBlock from 'theme/components/core/blocks/Shop/Navigation/Burger/BurgerBlock'
import BounceLoader from 'theme/components/theme/blocks/Home/Preloaders/BounceLoader'

export default {
  components: {
    CategoryBurgerLink,
    BurgerBlock,
    BounceLoader
  },
  props: {
    isCategoriesLoaded: {
      type: Boolean,
      default: () => false
    },
    categories: {
      required: true
    }
  },
  data () {
    return {
      isBurgerActive: false,
      burgerData: {
        current_list: [],
        list_naming: '',
        current_category: {}
      },
      isBurgerBlockActive: false,
      isBurgerBlockCreated: false,
      arrayBurgerPath: [],
      root_category: '',
      discountedProductsLink: {
        name: 'Товари зі знижкою',
        url_path: 'discounted-products',
        url_key: 'discounted-products',
        slug: 'discounted-products',
        children_count: 0,
        children_data: [],
        product_count: 0
      }
    }
  },
  created () {
    this.$bus.$on('show-burger-menu', () => {
      this.showBurger()
    })
    this.$bus.$on('hide-burger-menu', () => {
      this.hideBurger()
    })
    this.$bus.$on('open-burger', payload => {
      this.burgerData = Object.assign({}, payload)
      if (payload.hasOwnProperty('root_category')) {
        this.root_category = payload.root_category
      }
      this.isBurgerActive = true
    })
    this.$bus.$on('close-burger', () => {
      this.arrayBurgerPath = []
      this.isBurgerActive = false
    })
    this.$bus.$on('burger-path', this.burgerPath)
    this.$bus.$on('beck-burger', this.burgerBackPath)
  },
  watch: {
    '$route.path': {
      handler () {
        this.hideBurger()
        this.isBurgerActive = false
        this.$bus.$emit('hide-overlay-in-shop')
      }
    },
    isBurgerBlockActive: {
      handler() {
        this.$bus.$emit('changes-burger-icon', this.isBurgerBlockActive)
      }
    }
  },
  methods: {
    showBurger () {
      this.isBurgerBlockCreated = true
      setTimeout(() => { this.isBurgerBlockActive = true }, 100)
      this.changeBodyOverflow(true)
    },
    hideBurger () {
      this.isBurgerBlockActive = false
      setTimeout(() => { this.isBurgerBlockCreated = false }, 100)
      this.changeBodyOverflow(false)
    },
    changeBodyOverflow (flag) {
      const body = document.getElementsByTagName('body')[0];
      if (flag) body.style.overflowY = 'hidden'
      else body.style.overflowY = 'auto'
    },
    burgerPath (item) {
      this.arrayBurgerPath.push(item.name)
    },
    burgerBackPath () {
      let menu = {}
      this.arrayBurgerPath.pop()
      if (this.arrayBurgerPath.length) {
        menu = this.root_category
      } else {
        menu = {}
      }
      const payload = {
        current_list: menu.children_data,
        list_naming: menu.name,
        product_count: menu.product_count,
        current_category: menu
      }
      this.burgerData = Object.assign({}, payload)
      this.isBurgerActive = true

    }
  },
  beforeDestroy () {
    this.changeBodyOverflow(false)
    this.$bus.$off('burger-path', this.burgerPath)
  }
}
</script>

<style lang="scss" scoped>
.burger {
  width: 300px;
  height: 100%;
  margin-top: 105px;

  display: flex;
  z-index: 4;
  transition: .2s;

  &-block {
    width: 300px;
    height: calc(100vh - 105px); // 105px - height of header and navigation

    position: fixed;
    left: -300px;
    display: none;

    background: #fff;
    transition: .2s;

    &.is-active {
      left: 0;
    }

    &.is-created {
      display: flex;
    }

    &-list {
      width: 100%;

      display: flex;
      flex-direction: column;

      overflow-y: scroll;

      &::-webkit-scrollbar {
        width: 0;
      }

      &::-webkit-scrollbar-track {
        border-radius: 10px;
        background: #fff;
      }

      &::-webkit-scrollbar-thumb {
        width: 0;
        border-radius: 10px;
        background: #f5a623;
      }
    }
  }
}
</style>
